module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAABHNCSVQICAgIfAhkiAAAARpJREFUOI2NUstxwjAU3BVxC2FSA8k1cIvcAtBN4rE9QDeQFqRjwhVSA0NaAPvlIBiwJdl5x6d5+9MSACa7gxYqA9BSqvLr5cmiZwgA4/2vAUTfrXsBeGPzR4hiOxqWoTdVK/UWRRUU4/1RJruD9t4A4PXnmFNQxABC8nldO8mDvOk1DPD9/Jiyvf4PgBCFd9gECIdGqX3G9vj+nVTVd7gdDUtKnQK014CASzjzxUkLmTsZUq6zxPYBKgBwR9QAtVCZ6arK+w7p2OIhxNg7myNUZrY8m/nipD1QAJgtz8ZJ7Rqx9/4VAGw+HlKXnARlXTga/r1/7PJ8s9DRnOmqihafUscL8Pk+KMPyxa6zxHY2Z50ltu2fIiUA/AHe+JqHp/wu1QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/标题点缀1.png
// module id = 3eU1
// module chunks = 2